import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { TextP } from '../../Defaults/Text';
import * as arrowSrc from '../../../../assets/zemplin/list-arrow.svg';

export interface Props {
  url: string;
  title: string;
  hasIcon?: boolean;
}

function FooterItem({ url, title, hasIcon }: Props) {
  return (
    <Wrapper title={title} to={url}>
      <DesktopWrapper>
        {hasIcon && (
          <IconImg
            src={arrowSrc.toString()}
            alt="arrow"
            width={12}
            height={12}
            cursor="pointer"
          />
        )}
      </DesktopWrapper>
      <Text>{title}</Text>
    </Wrapper>
  );
}

const Wrapper = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-flow: row;
  align-items: center;
  margin-bottom: ${rem(16)};
  color: ${({ theme }) => theme.colors.footerLink};
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }

  &:last-child {
    ${({ theme }) => theme.mediab.m580`
      margin-bottom: ${rem(24)};
    `}
  }
`;

const DesktopWrapper = styled.div`
  display: block;

  ${({ theme }) => theme.mediab.m580`
    display: none;
  `}
`;

const Text = styled(TextP)`
  margin-left: ${rem(8)};
  font-weight: 400;
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.footerLink};
  line-height: ${rem(22)};

  ${({ theme }) => theme.mediab.m580`
    margin: 0;
  `}
`;

function areEqual(prev: Props, next: Props) {
  return prev.url === next.url && prev.title === next.title;
}
const MemoizedFooterItem = React.memo(FooterItem, areEqual);
export { MemoizedFooterItem as FooterItem };
